import axios from "axios";
import React, { useState } from "react";
import { BASE_URL_PREBID } from "../../../config/axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ToastContainer    , toast } from "react-toastify";

const ReceivedAmount = ({ id, maxlimitreceive }) => {
  // Modal Section
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    rec_date: "",
    amount_recived: ""
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ['rec_date', 'amount_recived'];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });


    // Check if received amount exceeds the max limit
    if (formData.amount_recived > maxlimitreceive) {
      newErrors['amount_recived'] = `Received amount cannot exceed ${maxlimitreceive}`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(`${BASE_URL_PREBID}/project/invoiceUpdate/${id}/`, formData);

        if (res.status === 200) {
          window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        if (err.response) {
          const errorData = err.response.data;

          if (typeof errorData.error === 'string') {
              // Single error message
              toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {
              // Multiple error messages
              Object.entries(errorData).forEach(([field, messages]) => {
                  messages.forEach(message => toast.error(`"${field}": ${message}`));
              });
          } else {
              toast.error('Error:- Failed to Process!');
          }
      } else {
          toast.error('Error processing your request.');
      }
      }finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
    }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      {/* <button className="models-button model-add" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_1415_3177)">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
              fill="#2576BC"
            />
          </g>
          <defs>
            <clipPath id="clip0_1415_3177">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button> */}
       <button
        title="Add Recieved Details"
        onClick={handleShow}
        className="upload-svga "

      >

        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill='white' id="add"><path d="M2.4375,17.9375h11.625v11.625c0,1.06854,0.86896,1.9375,1.9375,1.9375s1.9375-0.86896,1.9375-1.9375v-11.625h11.625c1.06854,0,1.9375-0.86896,1.9375-1.9375s-0.86896-1.9375-1.9375-1.9375h-11.625V2.4375C17.9375,1.36896,17.06854,0.5,16,0.5s-1.9375,0.86896-1.9375,1.9375v11.625H2.4375C1.36896,14.0625,0.5,14.93146,0.5,16S1.36896,17.9375,2.4375,17.9375z"></path></svg>

      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="dialog-modal-assign-task"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal-title">Recieved Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='modal-body-padding'>
            <form>
              <div className='form-flex-wrap'>
                <div className="flex-column">
                  <label>Received Date:<span className="required">*</span></label>
                  <input
                    type="date"
                    name="rec_date"
                    value={formData.rec_date}
                    onChange={handleInputChange}
                    className={`form-input ${errors.rec_date ? 'error' : inputState.rec_date ? 'success' : ''}`}
                  />
                  {errors.rec_date && <span className="error-message">{errors.rec_date}</span>}
                </div>

                <div className="flex-column">
                  <label>Received Amount:<span className="required">*</span></label>
                  <input
                    type="number"
                    name="amount_recived"
                    value={formData.amount_recived}
                    onChange={handleInputChange}
                    max={maxlimitreceive}  // Set the max limit here
                    className={`form-input ${errors.amount_recived ? 'error' : inputState.amount_recived ? 'success' : ''}`}
                  />
                  {errors.amount_recived && <span className="error-message">{errors.amount_recived}</span>}
                </div>
              </div>

              <div className="button-models">
                <button onClick={handleSubmit} className="model-button model-button-submit">Submit</button>
              </div>
            </form>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ReceivedAmount;
